import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash/fp';
import ReactDOM from 'react-dom';
import classnames from 'classnames';

import { isDesktop } from '../../../../config';
import styles from './education.module.css';
import SectionTitle from '../../../components/PracticeInfo/SectionTitle/index';

class Education extends Component {
  static propTypes = {
    education: PropTypes.arrayOf(PropTypes.string).isRequired,
  };
  state = {
    showAllEducation: false,
    divHeight: 45,
  };
  // TODO: Sort out ReadMores and setState
  componentDidMount() {
    setTimeout(this.setDivHeight, 100);
  }
  setDivHeight = () => {
    const divHeight =
      this.heightCheck && ReactDOM.findDOMNode(this.heightCheck).clientHeight;
    this.setState({
      divHeight,
    });
  };
  seeMore = () => {
    this.setState({
      showAllEducation: true,
    });
  };
  render() {
    return (
      <div className={styles.container}>
        <SectionTitle title="Qualifications" />
        {isDesktop() &&
          this.state.divHeight > 90 &&
          !this.state.showAllEducation && (
            <span className={styles.seeMore} onClick={this.seeMore}>
              See More
            </span>
          )}
        <div
          className={classnames(styles.educationContainer, {
            [styles.educationContainerAll]: this.state.showAllEducation,
          })}
        >
          <div
            className={styles.heightCheck}
            ref={c => {
              this.heightCheck = c;
            }}
          >
            {map(
              l => (
                <span className={styles.education} key={l}>
                  {l}
                </span>
              ),
              this.props.education,
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Education;
